import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLibraries, getDeviceConfigurationUsage, deleteLibrary } from 'actions/index';
import PropTypes from 'prop-types';
import LibraryListView from './LibraryListView';

class LibraryListContainer extends Component {
  componentDidMount() {
    const { fetchLibraries } = this.props;

    fetchLibraries();
  }

  render() {
    const {
      list,
      pages,
      currentPage,
      loading,
      fetchLibraries,
      removeLibrary,
      deviceConfigurationUsage,
      fetchDeviceConfigurationUsage,
    } = this.props;

    return (
      <LibraryListView
        list={list}
        pages={pages}
        currentPage={currentPage}
        loading={loading}
        fetchLibraries={fetchLibraries}
        removeLibrary={removeLibrary}
        deviceConfigurationUsage={deviceConfigurationUsage}
        fetchDeviceConfigurationUsage={fetchDeviceConfigurationUsage}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    list: state.libraries.list,
    pages: state.libraries.pages,
    currentPage: state.libraries.currentPage,
    loading: state.libraries.loading,
    deviceConfigurationUsage: state.libraries.deviceConfigurationUsage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchLibraries: params => dispatch(getLibraries(params)),
    removeLibrary: (id, reference, type) => dispatch(deleteLibrary(id, reference, type)),
    fetchDeviceConfigurationUsage: params => dispatch(getDeviceConfigurationUsage(params)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LibraryListContainer);

LibraryListContainer.propTypes = {
  currentPage: PropTypes.number,
  deviceConfigurationUsage: PropTypes.array,
  fetchDeviceConfigurationUsage: PropTypes.func,
  fetchLibraries: PropTypes.func,
  list: PropTypes.array,
  loading: PropTypes.bool,
  pages: PropTypes.number,
  removeLibrary: PropTypes.func,
};
